export default __webpack_public_path__ + "static/media/Group 26048.59b2d45a.svg";